export const getItemTypeText = (itemType) => {
    const itemTypeMap = {
        'T-O-T': 'Trabajo en Otro Taller',
        'Refaccion': 'Refacción',
        'UPB': 'Usada pero buena',
        'SupplierWorkshop': 'Insumo del taller'
    };

    return itemTypeMap[itemType] || itemType;
};